const instance = {
  baseURL: 'https://elementcontrol.azurewebsites.net/api/',
  // baseURL: 'http://192.168.18.10:4000/api/'
  // baseURL: 'http://192.168.15.34:4000/api/',
  // baseURL: 'http://localhost:4000/api/',
};

export default instance;
